module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv2-9c47c9665697f3e493f20cfe243e877e.jpg";